export const validateHasYourFamilyStartedSaving = hasYourFamilyStartedSaving => () => {
  const errors = [];
  if (hasYourFamilyStartedSaving !== true && hasYourFamilyStartedSaving !== false) {
    errors.push('Please select an option');
  }
  return errors;
};
export const validateAccounts = () => () => true;
